export default __webpack_public_path__ + "static/media/in_review.42c10a70.png";